import {
  SiGo, SiPostgresql, SiMysql, SiMongodb, SiSqlite, SiRedis, SiApachekafka, SiRabbitmq,
  SiDocker, SiKubernetes, SiAmazonaws, SiGooglecloud, SiDigitalocean, SiHetzner,
  SiTwilio, SiCloudflare, SiFfmpeg, SiReact, SiVite, SiEthereum, SiSolidity, SiGraphql,
  SiSocketdotio, SiJsonwebtokens, SiLinux, SiGnubash, SiGit, SiPostman, SiTypescript,
  SiGithubactions, SiNginx,
} from "react-icons/si";

// Technologies shown in the marquee / tech grid. Colours are tuned for a dark background.
export const tech = [
  { name: "Go", Icon: SiGo, color: "#00ADD8" },
  { name: "PostgreSQL", Icon: SiPostgresql, color: "#5B9BD5" },
  { name: "MySQL", Icon: SiMysql, color: "#4DA3D4" },
  { name: "MongoDB", Icon: SiMongodb, color: "#47A248" },
  { name: "Redis", Icon: SiRedis, color: "#E5473B" },
  { name: "SQLite", Icon: SiSqlite, color: "#5FB3E8" },
  { name: "Kafka", Icon: SiApachekafka, color: "#E8E8E8" },
  { name: "RabbitMQ", Icon: SiRabbitmq, color: "#FF6600" },
  { name: "GraphQL", Icon: SiGraphql, color: "#E10098" },
  { name: "Socket.IO", Icon: SiSocketdotio, color: "#FFFFFF" },
  { name: "JWT", Icon: SiJsonwebtokens, color: "#F5457A" },
  { name: "Docker", Icon: SiDocker, color: "#2496ED" },
  { name: "Kubernetes", Icon: SiKubernetes, color: "#5B8DEF" },
  { name: "AWS", Icon: SiAmazonaws, color: "#FF9900" },
  { name: "GCP", Icon: SiGooglecloud, color: "#4285F4" },
  { name: "DigitalOcean", Icon: SiDigitalocean, color: "#0080FF" },
  { name: "Hetzner", Icon: SiHetzner, color: "#E5322D" },
  { name: "Cloudflare", Icon: SiCloudflare, color: "#F6821F" },
  { name: "Twilio", Icon: SiTwilio, color: "#F22F46" },
  { name: "CI/CD", Icon: SiGithubactions, color: "#7C9CFF" },
  { name: "Nginx", Icon: SiNginx, color: "#2FBF71" },
  { name: "Linux", Icon: SiLinux, color: "#FCC624" },
  { name: "Bash", Icon: SiGnubash, color: "#8FE388" },
  { name: "FFmpeg", Icon: SiFfmpeg, color: "#44C25A" },
  { name: "React", Icon: SiReact, color: "#61DAFB" },
  { name: "Vite", Icon: SiVite, color: "#A98BFF" },
  { name: "TypeScript", Icon: SiTypescript, color: "#3178C6" },
  { name: "Solidity", Icon: SiSolidity, color: "#9AA5B1" },
  { name: "Ethereum", Icon: SiEthereum, color: "#8C9EFF" },
  { name: "Git", Icon: SiGit, color: "#F05032" },
  { name: "Postman", Icon: SiPostman, color: "#FF6C37" },
];

const byName = Object.fromEntries(tech.map((t) => [t.name, t]));
export const pick = (...names) => names.map((n) => byName[n]).filter(Boolean);
